import { TimecardModel } from "src/app/models/timecard";

export interface TimecardsState
{
    models: Record<string, TimecardModel>;
    pagination: { limit: number, page: number, pagesCount: number };
    timecards: string[];
}

export const TIMECARDS_FEATURE_KEY = 'timecards';